/** @format */

import { Component, computed, input } from '@angular/core';

import { FacetVO } from '@plp/data-access/interfaces';
import { ShippingOptionButtonComponent } from '../shipping-option-button/shipping-option-button.component';

@Component({
	selector: 'plp-components-exposed-filters',
	imports: [ShippingOptionButtonComponent],
	templateUrl: './exposed-filters.component.html',
	styleUrl: './exposed-filters.component.scss'
})
export class ExposedFiltersComponent {
	filter = input<FacetVO>();

	exposedFilter = computed(() => {
		return { label: this.filter()?.attrName, valueList: this.filter()?.valueList };
	});
}
